module.exports = __webpack_public_path__ + "img/shield-icon-y.649d955c.png";